import {createSlice} from '@reduxjs/toolkit';
import {RootState} from "../../app/store";

export interface EnvState {
    confirmModalOpen: boolean,
}

export const initialState: EnvState = {
    confirmModalOpen: false,
};

export const slice = createSlice({
    name: 'env',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        openConfirm: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.confirmModalOpen = true;
        },
        closeConfirm: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.confirmModalOpen = false;
        }
    },
});

export const {
    openConfirm,
    closeConfirm
} = slice.actions;
export default slice.reducer;

// Selector:
export const selectIsOpen = (state: RootState) => state.env.confirmModalOpen;